import "svix-react/dist/style.css";

import { notification, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { GuildTagsProvider } from "./DiscordTagsContext";
import SlackWorkspaceSettings from "./SlackWorkspaceSettings";
import SlackMemberDirectory from "./SlackMemberDirectory";
import EditTags from "./EditTags";
import General from "./General";
import Integrations from "./Integrations";
import Billing from "./Billing";

/**
 * Displays settings page for discord and slack
 * @returns JSX
 */
export default function Settings() {
  const [currentTab, setCurrentTab] = useState("general");
  const location = useLocation();
  const navigate = useNavigate();
  const currentPlatform = localStorage.getItem("platform") as
    | "slack"
    | "discord"
    | null;

  // open copy notification
  const openKeyCopyNotification = () => {
    notification.open({
      message: "Copied to clipboard!",
    });
    window.analytics.track("Zapier key copied");
  };

  useEffect(() => {
    document.title = "Settings | Dots";
  }, []);

  useEffect(() => {
    const initialTab = new URLSearchParams(location.search).get("tab");
    const existingTabs = [
      "general",
      "directory",
      "billing",
      "workspace",
      "integrations",
    ];
    // check if tab value obtained from query string exists
    if (typeof initialTab === "string" && existingTabs.includes(initialTab)) {
      setCurrentTab(initialTab);
    }
  }, [location]);

  return (
    <div>
      <Tabs
        onChange={(tab) => {
          navigate(`/settings?tab=${tab}`);
          window.analytics.track(`Switched to ${tab} tab in settings page`, {
            platform: currentPlatform,
          });
        }}
        activeKey={currentTab}
      >
        <Tabs.TabPane tab="General" key="general">
          <General currentPlatform={currentPlatform} />
        </Tabs.TabPane>
        {/* {currentPlatform === "discord" && (
          <Tabs.TabPane tab="Billing" key="billing">
            <Billing />
          </Tabs.TabPane>
        )} */}

        <Tabs.TabPane tab="Workspace level" key="workspace">
          {currentPlatform === "slack" ? (
            <SlackWorkspaceSettings />
          ) : (
            <div>
              <GuildTagsProvider>
                <EditTags />
              </GuildTagsProvider>
            </div>
          )}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Integrations" key="integrations">
          <Integrations />
        </Tabs.TabPane>
        {currentPlatform === "slack" && (
          <Tabs.TabPane tab="Member Directory" key="directory">
            <SlackMemberDirectory />
          </Tabs.TabPane>
        )}
      </Tabs>
    </div>
  );
}
